<template>
  <div>
    <v-btn @click="tagsState.modalOpen()" depressed small block class="mb-2">Текстовые теги</v-btn>
    <dialog-view :open="tagsState.modal" title="Текстовые теги" big @cancel="tagsState.modalClose()">
      <template v-slot:content>
        <v-data-table
            dense
            :headers="[
                    { text: 'Название', value: 'name', sortable: false, class:'text-no-wrap'},
                    { text: 'Пример', value: 'example', sortable: false, class:'text-no-wrap'},
                    { text: 'Тэг', value: 'tag', sortable: false, class:'text-no-wrap'},
                  ]"
            :items="tags"
            :server-items-length="tags.length"
            :loading="tagsState.isLoading"
            :hide-default-footer="true"
            :items-per-page="100"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <v-sheet width="700" color="transparent" class="text-wrap">
                  {{item.name}}
                </v-sheet>
              </td>
              <td class="text-no-wrap">{{item.example}}</td>
              <td class="text-no-wrap">
                <code style="user-select: all">{{item.tag}}</code>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </dialog-view>
  </div>
</template>

<script>
import Stater from "@/plugins/stater";
import axios from "axios";
import Api from "@/Api";
import DialogView from "@/components/DialogView.vue";

export default {
  components: {DialogView},
  data: () => ({
    tags:[],
    tagsState: new Stater(),
  }),
  mounted() {
    axios.get(Api.host+'/messenger/message/tag/').then((r)=> {
      this.tags = r.data;
    });
  },
}
</script>